export const useStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: '20rem',
        },
    };
};
